import { Modal } from 'antd'
import React from 'react'
import { BoxJobListModalProps } from '../interface'
import { BoxJobList } from './list'

export const BoxJobListModal: React.FC<BoxJobListModalProps> = (
  props: BoxJobListModalProps
) => {
  const { visible, onVisibleChange } = props

  return (
    <Modal
      title='任务列表'
      visible={visible}
      okText={'确认'}
      cancelButtonProps={{ style: { display: 'none' } }}
      width={800}
      maskClosable={false}
      destroyOnClose={true}
      onOk={() => onVisibleChange?.(false)}
      onCancel={() => onVisibleChange?.(false)}
    >
      <BoxJobList {...props} />
    </Modal>
  )
}
